var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"photo-list"},_vm._l((_vm.photos),function(photo){return _c('li',{key:photo._id,staticClass:"photo-list__photo"},[_c('img',{attrs:{"src":_vm.urlFor(photo.photo)
                        .size(300, 300)
                        .url(),"alt":""}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }